import React from 'react'
import PropTypes from 'prop-types'
import { Anchor, ActionAnchor } from '../common/Anchor'
import { Tooltip, Icon } from '../common/Ant'
import { hasPermission } from '../../utils/hasPermission'
import { USER_PERMISSIONS } from '../../constants'

const PressureMonitorSidebar = ({
  pressureMonitorId,
  pressureMonitorPillarId,
  alertActive,
  pressureMonitorOnline,
  handleCancel,
}) => {
  return (
    <span>
      {hasPermission(USER_PERMISSIONS.VIEW_PRESSURE_MONITOR) ? (
        <span>
          <ActionAnchor onClick={handleCancel}>
            <Anchor to={`/inventory/pressure-monitors/${pressureMonitorId}`}>
              {pressureMonitorPillarId}
            </Anchor>
          </ActionAnchor>
        </span>
      ) : (
        <span>{pressureMonitorPillarId}</span>
      )}
      {alertActive || pressureMonitorOnline === false ? (
        <Tooltip title="Offline">
          <Icon type="poweroff" className="pl1 red f4" />
        </Tooltip>
      ) : (
        <Tooltip title="Online">
          <Icon type="check-circle-o" className="pl1 green f4" />
        </Tooltip>
      )}
    </span>
  )
}

PressureMonitorSidebar.propTypes = {
  pressureMonitorId: PropTypes.number.isRequired,
  pressureMonitorPillarId: PropTypes.string.isRequired,
  handleCancel: PropTypes.func.isRequired,
  alertActive: PropTypes.bool.isRequired,
  pressureMonitorOnline: PropTypes.bool,
}

export default PressureMonitorSidebar
